// extracted by mini-css-extract-plugin
var _1 = "MetricLabel-module__animateUploadProgressBarWidth--OGdJM";
var _2 = "MetricLabel-module__animatedBackground--IKCZ_";
var _3 = "MetricLabel-module__arrow--mICje";
var _4 = "MetricLabel-module__change--wcpXo";
var _5 = "MetricLabel-module__circle--UUJkw";
var _6 = "MetricLabel-module__content--my24A";
var _7 = "MetricLabel-module__disabled--q99AD";
var _8 = "MetricLabel-module__down--zUWT_";
var _9 = "MetricLabel-module__headerButton--g_AkM";
var _a = "MetricLabel-module__name--BmKLk";
var _b = "MetricLabel-module__small--bY1FU";
var _c = "MetricLabel-module__tooltip--M_lYF";
var _d = "MetricLabel-module__up--PUpyn";
var _e = "MetricLabel-module__value--wiCQN";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "arrow", _4 as "change", _5 as "circle", _6 as "content", _7 as "disabled", _8 as "down", _9 as "headerButton", _a as "name", _b as "small", _c as "tooltip", _d as "up", _e as "value" }
